import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "news-feed" }
const _hoisted_2 = {
  key: 0,
  class: "no-articles"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  src: "/img/news_article_cover.jpg",
  alt: "News Media",
  class: "news-thumbnail"
}
const _hoisted_6 = { class: "news-content" }
const _hoisted_7 = {
  class: "title is-5",
  style: {"margin-bottom":"0"}
}
const _hoisted_8 = { class: "news-summary" }
const _hoisted_9 = { class: "news-author" }
const _hoisted_10 = {
  key: 0,
  class: "news-tags"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.newsFeed.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " No articles found. "))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.newsFeed, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item.Id,
            to: `/news/${item.UrlStub}`,
            class: "news-item"
          }, {
            default: _withCtx(() => [
              (_ctx.thumb && item.Media && !_ctx.extractYoutubeVideoId(item.Media))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: item.Media,
                    alt: "News Media",
                    class: "news-thumbnail"
                  }, null, 8, _hoisted_3))
                : (_ctx.thumb && item.Media && _ctx.extractYoutubeVideoId(item.Media))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: `https://img.youtube.com/vi/${_ctx.extractYoutubeVideoId(item.Media)}/maxresdefault.jpg`,
                      alt: "News Media",
                      class: "news-thumbnail"
                    }, null, 8, _hoisted_4))
                  : (_ctx.thumb)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h4", _hoisted_7, _toDisplayString(item.Title), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(item.Summary ? item.Summary : "No summary available."), 1),
                _createElementVNode("p", _hoisted_9, [
                  _cache[0] || (_cache[0] = _createTextVNode("By ")),
                  _createVNode(_component_router_link, {
                    to: `/profiles/${item.Author}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.Author), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createTextVNode(" on " + _toDisplayString(_ctx.formatDate(item.CreatedAt)), 1)
                ]),
                (item.Games && item.Games.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Games, (game) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: game,
                          class: "news-tag"
                        }, _toDisplayString(_ctx.gameNames.get(game)), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
  ]))
}